import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import CustomerSettings from "../models/CustomerSettings";

@Injectable({
  providedIn: "root",
})
export default class CustomerSettingsService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/customerSetting`;

  constructor(private http: HttpClient) {}

  public async getAllAsync(): Promise<CustomerSettings[]> {
    const response = await lastValueFrom(this.http.get<CustomerSettings[]>(`${this.baseUrl_V2}`));
    return response.map((x) => {
      return new CustomerSettings().deserialize(x);
    });
  }

  public async getAsync(companyId: string): Promise<CustomerSettings | undefined> {
    try {
      return await lastValueFrom(
        this.http.get<CustomerSettings>(`${this.baseUrl_V2}/${companyId}`),
      );
    } catch (error) {
      if (error.status === 404) {
        return undefined;
      } else {
        throw error;
      }
    }
  }

  public async addAsync(settings: CustomerSettings): Promise<CustomerSettings> {
    const response = await lastValueFrom(
      this.http.post<CustomerSettings>(`${this.baseUrl_V2}`, settings),
    );
    return new CustomerSettings().deserialize(response);
  }

  public async updateAsync(settings: CustomerSettings): Promise<CustomerSettings> {
    const response = await lastValueFrom(
      this.http.put<CustomerSettings>(`${this.baseUrl_V2}/${settings.companyId}`, settings),
    );
    return new CustomerSettings().deserialize(response);
  }
}
